import { Button, Chip, Stack } from '@mui/material';

type CustomerImportSummaryProps = {
  counts: {
    add: number;
    modify: number;
    remove: number;
    unchanged: number;
  };
  errorCount: number;
  showUnchanged: boolean;
  onToggleShowUnchanged(): void;
  isMiraLoading: boolean;
  isMiraError: boolean;
};

function CustomerImportSummary({
  counts,
  errorCount,
  showUnchanged,
  onToggleShowUnchanged,
  isMiraLoading,
  isMiraError,
}: CustomerImportSummaryProps) {
  return (
    <>
      {isMiraError && (
        <Chip
          label="Mira-tietojen haku epäonnistui"
          color="error"
          sx={{ mb: 2 }}
        />
      )}
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{ mb: 2, mt: 1 }}
      >
        {!isMiraLoading && (
          <>
            <Chip
              label={`Lisättävät: ${counts.add}`}
              color="success"
            />
            <Chip
              label={`Päivitettävät: ${counts.modify}`}
              color="warning"
            />
            <Chip
              label={`Poistettavat: ${counts.remove}`}
              color="error"
            />
            <Chip
              label={`Ei muutoksia: ${counts.unchanged}`}
              variant="outlined"
            />
            <Chip
              label={`Virheet: ${errorCount}`}
              color="default"
              variant="outlined"
              sx={{ color: '#d32f2f', borderColor: '#d32f2f' }}
            />
            <Button
              size="small"
              variant="text"
              onClick={onToggleShowUnchanged}
            >
              {showUnchanged
                ? 'Piilota muuttumattomat'
                : 'Näytä muuttumattomat'}
            </Button>
          </>
        )}
        {isMiraLoading && (
          <Chip label="Haetaan Mira-tietoja..." variant="outlined" />
        )}
      </Stack>
    </>
  );
}

export default CustomerImportSummary;
